<app-financial-account-balances
  [accountBalanceValues]="accountBalanceValues"
  [selectedCurrency]="selectedCurrency"
  [noBottomOffset]="noBottomOffset"
  [isLoading]="isLoading"
  [isFullWidth]="isFullWidth"
></app-financial-account-balances>
